import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { LandingPageBlockType } from './../../overrides/model/LandingPageBlockType.js';
import { LandingPage } from './../../overrides/model/LandingPage.js';
import { ChannelSimple } from './../../overrides/model/ChannelSimple.js';
import { LocaleTranslation } from './../../overrides/model/LocaleTranslation.js';
import { MediaSimple } from './../../overrides/model/MediaSimple.js';
import type { Constructor } from '@whispli/types';

export class __LandingPageBlock extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly title!: string;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly description!: string;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly locale!: string;
  /**
   * @deprecated For backwards-compatibility only. Use isVisible
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private is_visible!: boolean | null;

  @Expose({groups: ['client']})
  public get isVisible() {
    return this.is_visible
  }

  public set isVisible(value) {
    this.is_visible = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Number)
  public readonly order!: number;
  /**
   * @deprecated For backwards-compatibility only. Use mobileDeepLink
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private mobile_deep_link!: string | null;

  @Expose({groups: ['client']})
  public get mobileDeepLink() {
    return this.mobile_deep_link
  }

  public set mobileDeepLink(value) {
    this.mobile_deep_link = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use landingPageBlockTypeId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private landing_page_block_type_id!: string;

  @Expose({groups: ['client']})
  public get landingPageBlockTypeId() {
    return this.landing_page_block_type_id
  }

  public set landingPageBlockTypeId(value) {
    this.landing_page_block_type_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use landingPageBlockType
   */
  @Type(() => LandingPageBlockType)
  @Expose({groups:["server"]})
  private landing_page_block_type!: LandingPageBlockType | null;

  @Expose({groups: ['client']})
  public get landingPageBlockType() {
    return this.landing_page_block_type
  }

  public set landingPageBlockType(value) {
    this.landing_page_block_type = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use landingPageId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private landing_page_id!: string;

  @Expose({groups: ['client']})
  public get landingPageId() {
    return this.landing_page_id
  }

  public set landingPageId(value) {
    this.landing_page_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use landingPage
   */
  @Type(() => LandingPage)
  @Expose({groups:["server"]})
  private landing_page!: LandingPage | null;

  @Expose({groups: ['client']})
  public get landingPage() {
    return this.landing_page
  }

  public set landingPage(value) {
    this.landing_page = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use channelId
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private channel_id!: string | null;

  @Expose({groups: ['client']})
  public get channelId() {
    return this.channel_id
  }

  public set channelId(value) {
    this.channel_id = value
  }

  @Type(() => ChannelSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly channel!: ChannelSimple | null;
  @Type(() => LocaleTranslation)
  @Expose({ groups: ['client', 'server'] })
  public readonly translations!: (LocaleTranslation)[];
  @Type(() => MediaSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly media!: (MediaSimple)[];
  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_at!: string | null;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private updated_at!: string | null;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }
}
export type LandingPageBlock = Omit<__LandingPageBlock, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'is_visible' | 'mobile_deep_link' | 'landing_page_block_type_id' | 'landing_page_block_type' | 'landing_page_id' | 'landing_page' | 'channel_id' | 'created_at' | 'updated_at'>
export const LandingPageBlock = __LandingPageBlock as any as Constructor<LandingPageBlock>
